import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Bet } from '../domain/Bet.domain'

export const useDeleteBet = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/bets/${id}`)
    },
    onMutate: async (id) => {
      await queryClient.cancelQueries({ queryKey: [QueryKeys.Bets] })
      const previous = queryClient.getQueryData<Bet[]>([QueryKeys.Bets])
      queryClient.setQueryData<Bet[]>([QueryKeys.Bets], (old) =>
        old?.filter((b) => b.id !== id)
      )
      return { previous }
    },
    onError: (_err, _id, context) => {
      queryClient.setQueryData([QueryKeys.Bets], context?.previous)
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Bets] })
    },
  })
}
